import React, { useEffect, useState } from 'react';
import { Backdrop, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCloud,
  faCogs,
  faServer,
  faNetworkWired,
  faDatabase,
  faExclamationTriangle,
  faSync,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';

const useStyles = makeStyles()((theme: Theme) => ({
  '@keyframes bounce': {
    '0%, 100%': { transform: 'translateY(0)' },
    '50%': { transform: 'translateY(-10px)' },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    backgroundColor: 'transparent',
    backdropFilter: 'blur(10px)',
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
  },
  icon: {
    fontSize: '6rem',
    color: theme.palette.mode === 'dark' ? '#60a5fa' : '#2563eb',
    animation: `$bounce 1s ease-in-out infinite`,
  },
  iconWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    textAlign: 'center',
  },
  message: {
    marginTop: theme.spacing(2),
    fontSize: '1.5rem',
    color: theme.palette.mode === 'dark' ? '#cbd5e1' : '#1e293b',
    transition: 'opacity 0.5s ease-in-out',
  },
}));

const messages = [
  'Just a moment...',
  'Hang tight, things are loading...',
  'Almost there...',
  'Getting things ready...',
  'Loading, please wait...',
  'This won’t take long...',
  "Making sure everything's perfect...",
  'Fetching the good stuff...',
];

export const Loader = ({ loading }: { loading: boolean }) => {
  const { classes } = useStyles();
  const icons = [
    faCloud,
    faCogs,
    faServer,
    faNetworkWired,
    faDatabase,
    faExclamationTriangle,
    faSync,
    faCheckCircle,
  ];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % icons.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Backdrop className={classes.backdrop} open={loading}>
      <div className={classes.iconWrapper}>
        <FontAwesomeIcon icon={icons[index]} className={classes.icon} />
        <div className={classes.message}>{messages[index]}</div>
      </div>
    </Backdrop>
  );
};
